import { connect, ConnectedProps } from 'react-redux';
import Reports from './reports';
import {
  resetAssignCallOutcomeRequest,
  resetCreateCallLogsNoteRequest,
  resetExportCallReportsRequest,
  resetGetReportIndividualListRequest,
  resetGetReportsStatsRequest,
  resetGetReportTeamListRequest,
  setShowDialer,
} from '../../../../dialer-slice';
import {
  getReportTeamListRequest,
  getReportIndividualListRequest,
  getReportsStatsRequest,
  exportCallReportsRequest,
} from '../../../../extra-actions';
import { RootState } from '../../../../../../store/root-reducer';
import { ReportsPayload } from '../../../../types';

const mapStateToProps = (state: RootState) => ({
  showDialer: state?.dialer?.showDialer,
  callLogsListCountsResponse: state?.dialer?.callLogsListCountsResponse,
  getReportTeamListResponse: state?.dialer?.getReportTeamListResponse,
  getReportIndividualListResponse:
    state?.dialer?.getReportIndividualListResponse,
  getReportTeamListRequestStatus:
    state?.dialer?.getReportTeamListRequest?.status,
  getReportIndividualListRequestStatus:
    state?.dialer?.getReportIndividualListRequest?.status,
  getReportsStatsResponse: state?.dialer?.getReportsStatsResponse,
  getReportsStatsRequestStatus: state?.dialer?.getReportsStatsRequest?.status,
  teamMemeberListResponse: state?.usersAndTeams?.teamsAndUsersList,
  exportCallReportsRequestStatus:
    state?.dialer?.exportCallReportsRequest?.status,
  exportCallReportsResponse: state?.dialer?.exportCallReportsResponse,
  userRole: state?.home?.role,
  assignCallOutcomeRequestStatus: state?.dialer?.assignCallOutcomeRequest,
  createCallLogsNoteRequestStatus:
    state?.dialer?.createCallLogsNoteRequest?.status,
});

const mapDispatchToProps = {
  onMakeCallClick: (show: boolean) => setShowDialer(show),
  getReportTeamListRequest,
  getReportIndividualListRequest,
  getReportsStatsRequest,
  exportCallReportsRequest: (payload: ReportsPayload) =>
    exportCallReportsRequest(payload),
  resetGetReportTeamListRequest: () => resetGetReportTeamListRequest(),
  resetGetReportIndividualListRequest: () =>
    resetGetReportIndividualListRequest(),
  resetGetReportsStatsRequest: () => resetGetReportsStatsRequest(),
  resetExportCallReportsRequest: () => resetExportCallReportsRequest(),
  resetAssignCallOutcomeRequest: () => resetAssignCallOutcomeRequest(),
  resetCreateCallLogsNoteRequest: () => resetCreateCallLogsNoteRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IReportsProps = ConnectedProps<typeof connector>;

export default connector(Reports);
